import React from "react";
import { useContext, useEffect } from "react";
import DimensionsService from "../services/DimensionsService"
import AuthContext from '../store/AuthContext';
import DimensionInfo from "../models/DimensionInfo"
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import DimensionCard from "../components/DimensionCard";
import HeaderMobile from "components/header/HeaderMobile"
import NativeInterface from "services/NativeInterface"

const SavedPage: React.FC = () => {
    const authCtx = useContext(AuthContext);
    const [dimensions, setDimensions] = React.useState<DimensionInfo[]>([]);

    useEffect(() => {
        document.title=`DimensionX | Your Favourites`;

        let ids = authCtx.account.getAllDimensions();
        if (ids.length == 0) {
            setDimensions([]);
            return;
        }
        DimensionsService.listDimensions({ids: ids})
            .then((data: DimensionInfo[]) => {setDimensions(data)})
            .catch(error => console.error(`List dimensions error: ${error}`));
    }, [authCtx]);

    return (
        <>
            {!NativeInterface.isPWA() &&
                <div className="small-screen-only">
                    <HeaderMobile />
                </div>
            }
            <Row>
                {dimensions.map((item, index) => (
                    <Col xs={12} sm={12} md={6} lg={4} key={index}>
                        <DimensionCard data={item}/>
                    </Col>))}
            </Row>
        </>
    );
};

export default SavedPage;
